/**
 * Converts a number to an abbreviated string with K (thousands) or M (millions) suffix.
 * Useful for displaying large numbers in a compact format such as plan limits or statistics.
 *
 * @example
 * NumberToAbbv(1000000) // "1M"
 * NumberToAbbv(500000) // "500K"
 * NumberToAbbv(5000) // "5K"
 * NumberToAbbv(500) // "500"
 */
export default function NumberToAbbv(value: number): string {
    if (value >= 1000000) {
        return `${value / 1000000}M`
    }
    if (value >= 1000) {
        return `${value / 1000}K`
    }
    return value.toString()
}
